import { Observable } from "rxjs";
import { UseCase } from "../../../base/use-case";
import { ConfigurationRepository } from "../../../repositories/configuration.repository";
import { ThirdCompanyResponseModel } from "../../../models/configuration/company/third-company.model";

export class DeleteThirdCompanyUseCase implements UseCase<{ Id: string}, ThirdCompanyResponseModel> {
    constructor(private ThirdCompanyRepository: ConfigurationRepository) { }
    execute(
        params: {Id: string},
    ): Observable<ThirdCompanyResponseModel> {
        return this.ThirdCompanyRepository.deleteThirdCompany(params);
    }
}
